import React from 'react'
import styled from 'styled-components'
import tw from 'tailwind.macro'
import { Heading, Wrapper, Button } from '@/shared/styled'
import HeroIllustration from '@/components/svg/HeroIllustration'
import { sm } from '@/shared/responsive'
import showApplyPopup from '@/components/showApplyPopup'

const Container = styled.section`
  overflow: hidden;
  padding: 195px 0;
  ${tw`flex items-center flex-row relative`}
  ${sm`min-height: 882px;`}
`

const Desc = styled.p`
  font-size: 20px;
  opacity: 0.85;
  margin-top: 16px;
  max-width: 350px;
`

const InfoBlock = styled.div`
  padding-left: 14px;
  border-left: 4px solid ${props => props.theme.primary};
  margin: 30px 0 60px 0;
  p {
    line-height: 1.2em;
    opacity: 0.85;

    &:first-child {
      margin-bottom: 6px;
    }
  }
`

const Illustration = styled.div`
  position: absolute;
  width: 50%;
  top: 0;
  bottom: 0;
  ${sm`right:0;`}
  right: 100px;
`

const Reactangle = styled.div`
  height: 10000px;
  position: absolute;
  bottom: 40%;
  left: -100px;
  width: 565px;
  background-color: ${props => props.theme.greyLighter};
  transform-origin: 0 100%;
  border-radius: 100000px;
  transform: rotate(45deg);
`

const ComputerWrapper = styled.div`
  position: absolute;
  left: 40px;
  bottom: 154px;
`

const HeroSection = () => {
  return (
    <Container>
      <Wrapper>
        <div className="relative z-10">
          <Heading>Spring Internship 2019</Heading>
          <Desc>Build your first career goal with a Dwarf experience</Desc>
          <InfoBlock>
            <p>We’re calling for senior years technophiles</p>
            <p>
              Deadline: <span className="font-medium">20th March 2019</span>
            </p>
          </InfoBlock>
          {/* <Button onClick={showApplyPopup()} className="apply-btn" disabled>
            Apply now
          </Button> */}
          <Button className="apply-btn" disabled>
            Apply now
          </Button>
        </div>

        <Illustration>
          <Reactangle />
          <ComputerWrapper>
            <HeroIllustration />
          </ComputerWrapper>
        </Illustration>
      </Wrapper>
    </Container>
  )
}

export default HeroSection
